<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="600" >
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <v-icon>mdi-file-document-edit-outline</v-icon>                                                
                        <span>{{workType.name}}の作業記録項目</span>
                    </v-list-item-title>
                    <TitleButton
                        @click="onClickSave"
                        color="primary"
                        icon="mdi-floppy"
                        name="保存" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-row>
                        <v-col>
                            <v-select
                                v-model="editItems.type" 
                                dense
                                clearable 
                                label="種類"
                                :items="itemTypes"
                                item-text="text"
                                item-value="type"
                                outlined
                                :disabled="targetItem != null"
                                hide-details />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="editItems.name" 
                                dense
                                clearable 
                                label="作業記録項目の名前"
                                item-text="text"
                                outlined
                                hide-details />
                        </v-col>
                    </v-row>
                    <v-row v-if="editItems.type == 1 || editItems.type == 11">
                        <v-col>
                            <v-text-field
                                v-model="editItems.unit" 
                                dense
                                clearable 
                                label="作業記録項目の単位"
                                item-text="text"
                                outlined
                                hide-details />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>                
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            TitleButton,
            Confirm
        },
        props: {
            workType: null
        },
        data: function () {
            return {
                isView: false,
                targetPlace: null,
                targetWorkType: null,
                targetItem: null,
                editItems: {
                    type: 0,
                    name: "",
                    unit: ""
                },
                itemTypes: [
                    {type:1, text:"数値"},
                    {type:2, text:"文字"},
                    {type:3, text:"日付"},
                    {type:4, text:"時刻"},
                    // {type:7, text:"堆肥"},
                    // {type:8, text:"肥料"},
                    // {type:9, text:"農薬(※使用不可※)"},
                    {type:10, text:"使用農薬"},
                    {type:11, text:"出荷と販売"},
                    {type:12, text:"病気"},
                    {type:13, text:"害虫"},
                ],
                isCopyMode: false
            }
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
        },
        methods: {
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this
                var newRecordItem = null

                /** 登録レコード作成 */
                var recordItem = null
                if (this.targetItem == null || this.isCopyMode) {
                    var recordNo = Math.max(...this.workType.recordItems.map(m => m.recordNo)) + 1
                    if (recordNo <= 100) {
                        recordNo = 101
                    }
                    if (!this.isCopyMode) {
                        newRecordItem = {
                            placeID: this.targetPlace.body.placeID,
                            workTypeID: this.targetWorkType.workTypeID,
                            recordNo: recordNo,
                            orderNo: recordNo,
                            type: null,
                            name: "",
                            data: null,
                            register: {
                                userUID: this.userUID,
                                dateTime: this.df_currentDateTime()
                            }
                        }
                    } else {
                        newRecordItem = this.targetItem
                        newRecordItem.recordNo = recordNo
                        newRecordItem.orderNo = recordNo
                        newRecordItem.register = {
                            userUID: this.userUID,
                            dateTime: this.df_currentDateTime()
                        }
                    }
                    recordItem = newRecordItem
                } else {
                    recordItem = this.targetItem
                }

                recordItem.type = this.editItems.type
                recordItem.name = this.editItems.name
                switch (this.editItems.type) {
                    case 1:
                    case 11:
                        recordItem.data = {
                            unit: this.editItems.unit
                        }
                        break;
                }

                console.log("MaintenancePlaceWorkRecordItem", "onClickSave", recordItem)

                /** 登録 */
                db.collection("users").doc(this.userUID)
                .collection("places").doc(recordItem.placeID+"")
                .collection("place_work_types").doc(recordItem.workTypeID+"")
                .collection("record_items").doc(recordItem.recordNo+"")
                .set(recordItem).then(function(){
                    if (newRecordItem != null) {
                        self.workType.recordItems.push(newRecordItem)
                        self.$emit("onAddNewRecordItem", newRecordItem)
                    }
                    self.$store.commit("notification", {message:"作業記録項目を更新しました。"})
                }).catch (function(error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"作業記録項目の更新に失敗しました。", isError:true})
                    self.mi_writeLog("MaintenancePlaceWorkRecordItem/onClickSave", "作業記録項目の更新に失敗しました。("+error+")")
                })

                this.isView = false
            },
            /**
             * このダイアログを表示
             */
            show: function (place, workType, item, isCopyMode) {
                this.targetPlace = place
                this.targetWorkType = workType
                this.targetItem = item
                this.isCopyMode = isCopyMode
                if (item != null) {
                    this.editItems = {
                        type: item.type,
                        name: item.name,
                        unit: item.type == 1 || item.type == 11 ? item.data.unit : null
                    }
                } else {
                    this.editItems = {
                        type: 1,
                        name: "",
                        unit: ""
                    }
                }
                this.isView = true
            }
        }
    }
</script>
